export { default as Img200 } from './processed/200/Hansel&GretelWitchHunters.jpg';
export { default as Img400 } from './processed/400/Hansel&GretelWitchHunters.jpg';
export { default as Imgthumb } from './processed/thumb/Hansel&GretelWitchHunters.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Hansel&GretelWitchHunters.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Hansel&GretelWitchHunters.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      211,
      29,
      37
    ],
    "_population": 2228,
    "_hsl": [
      0.9926739926739927,
      0.7583333333333332,
      0.47058823529411764
    ]
  },
  "LightVibrant": {
    "_rgb": [
      242,
      252,
      250
    ],
    "_population": 91,
    "_hsl": [
      0.46666666666666634,
      0.6250000000000013,
      0.9686274509803922
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      111,
      57,
      42
    ],
    "_population": 528,
    "_hsl": [
      0.036231884057971016,
      0.4509803921568628,
      0.3
    ]
  },
  "Muted": {
    "_rgb": [
      163,
      84,
      100
    ],
    "_population": 13,
    "_hsl": [
      0.9662447257383966,
      0.3198380566801619,
      0.484313725490196
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      173,
      174
    ],
    "_population": 169,
    "_hsl": [
      0.9957264957264957,
      0.31200000000000017,
      0.7549019607843137
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      44,
      39
    ],
    "_population": 474,
    "_hsl": [
      0.028735632183908028,
      0.27102803738317754,
      0.20980392156862746
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Hansel&GretelWitchHunters.js